import React from 'react';
import { Reveal } from './Reveal';
import { BookButton } from './BookButton';
import { steps } from '../data/homepage';
export function HowItWorks() {
  return <section id="how-it-works" aria-labelledby="how-heading" className="bg-navy pb-24 pt-12 text-paper md:pb-32" data-id="element-111" data-mp="7qiopis3em7k">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-112" data-mp="3u03j1i76u3q5">
        <Reveal className="max-w-3xl" data-id="element-113" data-mp="3u0lkct8pj84x">
          <h2 id="how-heading" className="font-serif text-4xl font-semibold leading-tight md:text-5xl" data-id="element-114" data-mp="lk9yms9qk83t">
            How it works
          </h2>
          <p className="mt-6 text-lg text-paper/80 md:text-xl" data-id="element-115" data-mp="qi1qjmadru80">Four steps. We're with you for every one.</p>
        </Reveal>

        <ol className="relative mt-16 grid gap-12 lg:grid-cols-4 lg:gap-10" data-id="element-116" data-mp="crpz7plmdzhx">
          {/* Gold connecting line: vertical on mobile, horizontal on desktop */}
          <span aria-hidden="true" className="absolute bottom-8 left-7 top-8 w-px bg-gold/60 lg:hidden" data-id="element-117" data-mp="14ivyy4xfhv6o" />
          <span aria-hidden="true" className="absolute left-[calc(12.5%-1.25rem)] right-[calc(12.5%-1.25rem)] top-7 hidden h-px bg-gold/60 lg:block" data-id="element-118" data-mp="19aw6ojjqpsdt" />
          {steps.map((step, i) => <li key={step.title} className="relative" data-id="element-119" data-mp="2mo5vk5ctv5yu" data-mpi={i}>
              <Reveal delay={i * 0.06} className="flex gap-6 lg:flex-col lg:items-center lg:text-center" data-id="element-120" data-mp="31bzfg28y4un8">
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-gold bg-navy font-serif text-2xl font-semibold text-gold" data-id="element-121" data-mp="2wkhbr6fjgfyk">
                  {i + 1}
                </span>
                <div data-id="element-122" data-mp="36a0zoqi3z00a">
                  <h3 className="font-serif text-2xl font-semibold leading-snug lg:mt-6" data-id="element-123" data-mp="36cwu44uqz6jz">{step.title}</h3>
                  <p className="mt-3 text-lg leading-relaxed text-paper/80" data-id="element-124" data-mp="3k7z6nau3nu5r">{step.body}</p>
                </div>
              </Reveal>
            </li>)}
        </ol>

        <Reveal className="mt-16 flex justify-start lg:justify-center" data-id="element-125" data-mp="1pwkhav503wqj">
          <BookButton data-id="element-126" data-mp="1ky95wfz25e67" />
        </Reveal>
      </div>
    </section>;
}